import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { isFreshPageLoad } from "./NavigationTracker";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const history = useHistory();

  useEffect(() => {
    // On back/forward navigation (POP), leave scroll restoration to ScrollingSaver.
    // Only forward navigation (PUSH/REPLACE) into a new page, or a fresh page
    // load that react-router happens to also mark as POP (reload / typed URL),
    // should jump to top.
    if (history.action !== "POP" || isFreshPageLoad()) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
